import { AutoMap } from "@automapper/classes";

export class MeasureGenericDTO {
    @AutoMap()
    code!: string;
    @AutoMap()
    isCancelled!: boolean;
    @AutoMap()
    name!: string;
    @AutoMap()
    groupName!: string;
    @AutoMap()
    reference!: string;
    @AutoMap()
    observation!: string;
    @AutoMap()
    number!: number;
    @AutoMap()
    batchCode!: string;
    @AutoMap()
    isPrestationAnnexe!: boolean;
}